import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { BannerService } from "../Services/authService";
import { showSuccessToast, showErrorToast } from "../utils/toastUtils";
import "./slider.css";

class SliderCrousel2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondaryBanners: [],
    };
  }

  componentDidMount() {
    this.fetchSecondaryBanners();
  }

  async fetchSecondaryBanners() {
    try {
      const response = await BannerService();

      if (response?.status?.code === 200 || response?.status === 200) {
        const allBanners = response?.data || [];
        const secondary = allBanners.filter(
          (b) => b.banner_type.toLowerCase() === "secondary",
        );
        this.setState({ secondaryBanners: secondary });
      } else {
        showErrorToast("Unexpected response from server.");
      }
    } catch (error) {
      showErrorToast("Failed to fetch secondary banners.");
    }
  }

  render() {
    const { secondaryBanners } = this.state;

    const fallbackBanners = [
      {
        id: "fallback-1",
        src:
          process.env.PUBLIC_URL +
          "/media/slider_img/Aadhar Verification API for IT solution website.png",
        alt: "Aadhar Verification API",
      },
      {
        id: "fallback-2",
        src:
          process.env.PUBLIC_URL +
          "/media/slider_img/DL Verification API for IT Solution website.png",
        alt: "DL Verification API",
      },
      {
        id: "fallback-3",
        src:
          process.env.PUBLIC_URL +
          "/media/slider_img/IFSC verification API for IT solution website.png",
        alt: "IFSC Verification API",
      },
      {
        id: "fallback-4",
        src:
          process.env.PUBLIC_URL +
          "/media/slider_img/Pan verification API for IT solution website.png",
        alt: "Pan Verification API",
      },
    ];

    const bannersToShow =
      secondaryBanners.length > 0 ? secondaryBanners : null;

    return (
      <Carousel
        autoPlay={true}
        infiniteLoop={true}
        transitionTime={500}
        showThumbs={false}
        showIndicators={true}
        showArrows={false}
      >
        {bannersToShow?.map((banner) => (
          <div
            key={banner.id}
            style={{
              height: "530px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#2563EB",
              borderRadius: "20px",
            }}
          >
            <div className="zoom-wrapper">
              <img
                loading="lazy"
                src={
                  banner?.image_blob?.original?.dataUri
                    ? banner.image_blob.original.dataUri
                    : banner.src
                }
                alt={banner.alt || `banner-${banner.id}`}
              />
            </div>
          </div>
        ))}
      </Carousel>
    );
  }
}

export default SliderCrousel2;
